import NextLink from 'next/link';
import { useUser, useSupabaseClient } from '@supabase/auth-helpers-react';
import Image from 'next/image'
import { UserContext } from '../src/pages/_app';
import { useState, memo } from "react";
import { useGate } from 'statsig-react';
// import { renderAuthUI } from '../lib/utils';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';

const Modal = memo(function Modal(props) {
    const user = useUser();
    const trigger = props.trigger || "development";
    const modal_open = props.modal_open || false;
    //check if trigger contains "susi"
    // const flagName = trigger.startsWith("susi") ? "susi-incontext" : "default-v2";
    // const { value: incontext_susi } = useGate(flagName);    
    const susi_toast = false;
    const incontext_susi = trigger.startsWith("susi") ? true : false;
    const [isChecked, setIsChecked] = useState(modal_open);
    let redirectUrl = props.redirect_url || "/";
    const supabaseClient = useSupabaseClient()
    const MemoizedAuth = memo(Auth);
    const modal_id = props.modal_id || "my-modal";

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };    
    // let url = window !== undefined ? window.location.href : "/";
    let title;
    let body;
    let url;

    if (trigger == "susi") {
        title = "You need an account to use this feature"
        body = "Create or sign in to an account for access to this feature"
    }
    else if (trigger == "susi_eye_shape") {
        title = "You need an account to use this feature"
        body = "Create or sign in to an account to buy credits to use the Eye Shape Analyzer"
        url = "/face_analyzer"
        redirectUrl = "/face_analyzer/eye_shape"
    }
    else if (trigger == "susi_nose_contour") {
        title = "You need an account to use this feature"
        body = "Create or sign in to an account to buy credits to use the Nose Contour Guide"
        url = "/makeup_recommendations/face_contour"
        redirectUrl = "/makeup_recommendations/nose_contour"
    }
    else if (trigger == "premium_susi") {
        title = "You must be logged in to purchase credits"
        body = "Create or sign in to an account to complete the transaction"
        url = "/pricing"
        redirectUrl = "/pricing"
    }
    else if (trigger == "credit_alert") {
        title = "You don't have enough credits to use this feature"
        body = "Purchase more credits to continue using the Eye Shape Analyzer"
    }
    else {
        title = "This feature is still in development"
        body = user ? "We'll email you when it becomes available" : "Sign up for an account so you don't miss the release!"
        url = "/"
    }

    return (
    <>
    <input type="checkbox" id={modal_id} className="modal-toggle" onChange={handleCheckboxChange} />
    {susi_toast && isChecked ? 
          <div id="my-susi-toast" className={`z-[501] mx-auto toast toast-top toast-center ${modal_open ? 'modal-open' : null}`}>
          <div role="alert" className="alert shadow-lg bg-white flex flex-col">
          {modal_open ? <NextLink href={url} className="btn btn-sm btn-circle absolute right-5 top-5 bg-transparent btn-outline border-none z-[10]">✕</NextLink> : <label htmlFor="my-modal" className="btn btn-sm btn-circle absolute right-5 top-5 bg-transparent btn-outline border-none z-[10]">✕</label> }                                
            <div>
              <h3 className="font-bold mt-4 md:mt-0">{title}</h3>
              <div className="text-sm mt-1 text-wrap" style={{ whiteSpace: "pre-wrap" }}>{body}</div>
            </div>
            <div className="card-actions justify-center">
                    {user ? <label htmlFor="my-modal" className="btn btn-sm">Ok, got it</label> : 
                    <>
                    <NextLink href={{
                        pathname:`/login`,
                        query: {
                            redirect_url: props.redirect_url || "/"
                        }
                    }}
                    as={`/login`}
                    >
                        <button className="btn btn-sm">Sign in</button>
                    </NextLink>
                    <NextLink 
                    href={{
                        pathname:`/login`,
                        query: {
                            sign_up: true,
                            redirect_url: props.redirect_url || "/"
                        }
                    }}
                        as={`/login?sign_up=true`}
                    >
                        <button className="btn btn-neutral text-white btn-sm">Sign up</button></NextLink>
                    </>                
                    }
                </div>            
            {/* <button className="btn btn-sm bg-blue-500 hover:bg-blue-600 text-white md:mt-2 " onClick={handleRefresh}>Refresh Page</button> */}
          </div>
          </div>          
        : 
    <>    
    <div id={modal_id} className={`modal ${modal_open ? 'modal-open' : null}`}>
        <div className="modal-box card lg:card-side bg-base-100 p-0 w-[300px] md:w-[680px] lg:w-[840px] md:max-w-[50%]">
            {modal_open ? <NextLink href={url} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</NextLink> : <label htmlFor={modal_id} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent btn-outline border-none z-[10]">✕</label> }                
            <div className="card-body">
                <h2 className="card-title">{title}</h2>
                {incontext_susi && isChecked ? 
                <>
                <MemoizedAuth
                  redirectTo={window.location.origin + redirectUrl}
                  appearance={{
                      theme: ThemeSupa,
                      className: {
                          button: 'btn',
                          anchor: 'link text-black',
                          label: 'label-text text-black',                  
                          container: 'w-full'
                      },            
                      variables: {
                        default: {
                          colors: {
                            brand: 'hsl(219 14.085% 27.843%)',
                            brandAccent: 'hsl(219 14.085% 22.275%)',
                          },
                        },
                      },
                  }}        
                  supabaseClient={supabaseClient}
                  providers={['google']}
                  view={'sign_up'}
                />                
                </> 
                : 
                <>
                <br/>
                <p>{body}</p>
                <br/>
                <div className="card-actions justify-center md:justify-end">
                    {user ? <label htmlFor="my-modal" className="btn">Ok, got it</label> : 
                    <>
                    <NextLink href={{
                        pathname:`/login`,
                        query: {
                            redirect_url: props.redirect_url || "/"
                        }
                    }}
                    as={`/login`}
                    >
                        <button className="btn">Sign in</button>
                    </NextLink>
                    <NextLink 
                    href={{
                        pathname:`/login`,
                        query: {
                            sign_up: true,
                            redirect_url: props.redirect_url || "/"
                        }
                    }}
                        as={`/login?sign_up=true`}
                    >
                        <button className="btn btn-neutral text-white">Sign up</button></NextLink>
                    </>                
                    }
                </div>                
                </>}

            </div>
        </div>
    </div>  
    </> 
    }
    </>
    )
})

export default Modal;

